import { RuleAudienceIcon } from '@/lib';
import { FC, SVGProps } from 'react';
import { LuCalendar } from 'react-icons/lu';
import { twMerge } from 'tailwind-merge';

type IconProps = { className?: string };

export const AudienceFilterIcon: FC<IconProps> = ({ className }) => (
  <RuleAudienceIcon className={twMerge('size-4 text-primary-600', className)} aria-hidden />
);

export const CalendarFilterIcon: FC<IconProps> = ({ className }) => (
  <LuCalendar className={twMerge('size-4 text-primary-600', className)} aria-hidden />
);

export const GoogleAdsIcon: FC<IconProps> = ({ className }) => (
  <span
    className={twMerge('grid size-5 shrink-0 place-items-center rounded-full bg-white text-[10px] font-bold text-[#4285F4]', className)}
    aria-hidden
  >
    G
  </span>
);

export const MetaIcon: FC<IconProps> = ({ className }) => (
  <svg viewBox='0 0 24 24' className={twMerge('size-5 shrink-0 text-[#0081FB]', className)} aria-hidden>
    <path
      fill='currentColor'
      d='M12 2c-2.5 3.5-5 7.5-5 11a5 5 0 0 0 10 0c0-3.5-2.5-7.5-5-11zm0 14a3 3 0 0 1-3-3c0-2 1.5-4.5 3-7 1.5 2.5 3 5 3 7a3 3 0 0 1-3 3z'
    />
  </svg>
);

export const BarChartHeaderIcon: FC<SVGProps<SVGSVGElement>> = ({ className, ...props }) => (
  <svg viewBox='0 0 20 20' fill='none' className={twMerge('size-5 text-brand-600', className)} aria-hidden {...props}>
    <path d='M3 16V8M8 16V4M13 16V10M18 16V6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
  </svg>
);
